import { render, staticRenderFns } from "./RecoveryPassword.vue?vue&type=template&id=65d00bc7&scoped=true"
import script from "./RecoveryPassword.vue?vue&type=script&lang=ts"
export * from "./RecoveryPassword.vue?vue&type=script&lang=ts"
import style0 from "./RecoveryPassword.vue?vue&type=style&index=0&id=65d00bc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d00bc7",
  null
  
)

export default component.exports